<div class="manage-messaging-container">

  <section class="manage-messaging-container-titlebar">
    <div class="titlebar-left">
      <h3><i class="fa-regular fa-envelope"></i> Messaging</h3>
      <p>
        Edit your your message templates and rules for sending messages to users with various channels like email, SMS, WhatsApp, Slack, etc.
      </p>
    </div>
    <div class="titlebar-right">

      <!-- <button
              nz-button
              nz-tooltip
              [nzTooltipTitle]="'Display data tables'"
              nzType="default"
              nzSize="small"
              class="tables-home-button"
              (click)="onDbHomeButtonClicked()">
        <i class="fa-regular fa-table"></i>&nbsp;All Tables
      </button> -->
    </div>

  </section>

  <div class="ui-management-cards">

    <rappider-card-icon-title-description-list [items]="uiManagementCards?.concat(messageTemplateCards ?? [])"
                                               (cardClick)="onUiManagementCardCardClicked($event)">
    </rappider-card-icon-title-description-list>

  </div>

</div>
